/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import Model from '@tripian/model';
import { FormTemplateRegister } from '@tripian/react';

import config from '../../config';
import * as gtag from '../../gtag';
import { REGISTER, LOGIN, USE_TRIP_URL, NOT_FOUND } from '../../constants/ROUTER_PATH_TITLE';

import useAuth from '../../hooks/useAuth';

const RegisterPage = () => {
  const { isLoggedIn, registerEmail } = useAuth();
  const history = useHistory();
  const location = useLocation();

  document.title = REGISTER.TITLE;

  useEffect(() => {
    // Already logged in. Redirect to where came from or home
    if (isLoggedIn) {
      const from: any = location.state || { from: { pathname: '/' } };
      history.replace(from.from);

      // HIDE LOGIN for butter redirect to hash login
    } else if (config.HIDE_LOGIN) {
      history.replace(USE_TRIP_URL.PATH);

      // Register disabled, redirect to not found
    } else if (!config.SHOW_REGISTER) history.replace(NOT_FOUND.PATH);
    else {
      // Do nothing
    }
  }, [isLoggedIn, history, location]);

  const callbackSuccessRegister = (user: Model.User) => {
    gtag.googleAnalyticsEvent('Created new user', { user: user.username });
    history.push(LOGIN.PATH);
  };

  return (
    <>
      <div className="full-center-x">
        <div className="login-form-wrapper">
          <FormTemplateRegister register={registerEmail} successRegister={callbackSuccessRegister} reCaptchaSiteKey="6LcSweAUAAAAAJKsnLlDnnUTLFG6cspHMI1BJCfP" showCaptcha={false} />
          {/* <input type="button" value="Login" style={{ width: 'calc(100% - 10px)', padding: '10px', margin: '5px' }} onClick={loginHash} /> */}
          <br />
          <button
            type="button"
            onClick={() => {
              history.push('/login');
            }}
          >
            Login
          </button>{' '}
        </div>
      </div>
    </>
  );
};

export default RegisterPage;
